import type { FaireProductEntity } from "../../entity_types/product";

export const p_fns948ww3w: FaireProductEntity = {
  token: "p_fns948ww3w",
  type: "product",
  name: "Sambal Goreng Chili Topping - Bulk Jar!",
  brandToken: "b_nuvyk3uha5",
  brandName: "Bungkus Bagus",
  imageUrl:
    "https://cdn.faire.com/fastly/b75ae00e6b05cb8c2147546ad6cb024a3650dd535bcd49f623482617c8fa539f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8019d55f34ef6f485903b74d7226e392010f716b10d2ddb8193f4070336401f3.jpeg",
    "https://cdn.faire.com/fastly/72183cf3cc25afa53869a27e24a922e1be644536d01b2a0d608fb67d8e0bcd1c.jpeg",
    "https://cdn.faire.com/fastly/42ff98dd8b1f8ac28e0275cfd8f48e3451380b3f3d291a8d9aafbe0e0d950db0.jpeg",
    "https://cdn.faire.com/fastly/a73a4f551b49d6fc86361c96a49fed69c3f278be6cce072cad85740ded085305.jpeg",
    "https://cdn.faire.com/fastly/71395a3f3c2088382e5f4f78fb73a2bb89f64fc486e04dfd48b14c57376ea6dc.jpeg",
  ],
  priceDollars: 84,
  description:
    "*Our bulk jar is equivalent to 8 regular jars of Sambal Goreng.*\n\nA fiery crunch with a flavor punch!\n\nSambal Goreng, or spicy fried shallots and garlic, is a good-on-everything topping that instantly adds a bold kick and satisfying crunch to just about any dish. Use it while you cook. Sprinkle as a final flourish. Or snack on it, straight from the jar.\n\nWe make it the old-school way: by hand, with care. This is our love letter to Bali, whose flavors belong in every pantry.\n\nVegan - Gluten-Free - Peanut-Free - Soy-Free - No Added Sugar - No Preservatives\nNet Weight: 32 oz.\nIngredients: USA grown shallots and garlic, bird’s eye chili powder, salt, non-GMO canola oil.\nShelf life: store in a cool, dry place for up to six months.\n",
  tags: [],
  msrpDollars: 138,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:29.524Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
